module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1521-fa6386056bc34efd67c28d001d9c9aa4.png";